/**
 * rb-setting.js — Ring Builder: Colección de Monturas
 *
 * Las cards son <a> links a la PDP — este JS solo se encarga de:
 *   1. Mostrar la barra de diamante seleccionado si ?diamond= está en la URL
 *   2. Filtro de estilo (DOM-based sobre las cards pre-renderizadas)
 */

(function () {
  'use strict';

  var cfg = window.rbSettingConfig || {};

  // ── Init ────────────────────────────────────────────────────────────────────

  function init() {
    var diamondId = cfg.entryDiamondVariantId || '';
    if (/^\d+$/.test(diamondId)) {
      showDiamondBar(diamondId);
    }
    bindStyleFilters();
    bindCutFilters();
    preSelectCutFromUrl();
    updateCount();
  }

  // ── Diamond context bar ──────────────────────────────────────────────────────

  function showDiamondBar(diamondId) {
    var bar = document.getElementById('rb-diamond-context');
    if (!bar) return;
    bar.classList.remove('rb-hidden');

    var diamondData = null;
    try { diamondData = JSON.parse(sessionStorage.getItem('diamore_diamond') || 'null'); } catch (e) {}
    if (!diamondData) return;

    var infoEl  = document.getElementById('rb-context-diamond-info');
    var priceEl = document.getElementById('rb-context-diamond-price');

    if (infoEl) {
      var info = [
        diamondData.carat   ? diamondData.carat + ' ct' : '',
        diamondData.color   || '',
        diamondData.clarity || '',
        diamondData.cert_lab || '',
        diamondData.shape   || ''
      ].filter(Boolean).join(' · ');
      infoEl.textContent = info;
    }

    if (priceEl && diamondData.price_with_markup) {
      priceEl.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: 'USD'
      }).format(diamondData.price_with_markup);
    }
  }

  // ── Style filter ─────────────────────────────────────────────────────────────

  function bindStyleFilters() {
    document.querySelectorAll('#rb-setting-style-filters [data-style]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('#rb-setting-style-filters [data-style]').forEach(function (b) {
          b.classList.remove('rb-filter-btn--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('rb-filter-btn--active');
        btn.setAttribute('aria-pressed', 'true');
        applyFilters();
      });
    });
  }

  function getActiveCut() {
    var btn = document.querySelector('#rb-setting-shape-filters [data-cut].rb-filter-btn--active');
    return btn ? btn.dataset.cut : 'all';
  }

  function getActiveStyle() {
    var btn = document.querySelector('#rb-setting-style-filters [data-style].rb-filter-btn--active');
    return btn ? btn.dataset.style : 'all';
  }

  function applyFilters() {
    var style = getActiveStyle();
    var cut   = getActiveCut();
    var cards   = document.querySelectorAll('#rb-settings-grid .rb-setting-card');
    var visible = 0;
    cards.forEach(function (card) {
      var href = (card.getAttribute('href') || '').toLowerCase();
      var matchesCut   = cut === 'all' || href.includes(cut);
      var matchesStyle = style === 'all' || (card.dataset.style || '').toLowerCase() === style.toLowerCase();
      var show = matchesCut && matchesStyle;
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    updateCount(visible);
  }

  function filterByStyle(style) {
    applyFilters();
  }

  // ── Cut (diamond shape) filter ────────────────────────────────────────────────

  function bindCutFilters() {
    document.querySelectorAll('#rb-setting-shape-filters [data-cut]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('#rb-setting-shape-filters [data-cut]').forEach(function (b) {
          b.classList.remove('rb-filter-btn--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('rb-filter-btn--active');
        btn.setAttribute('aria-pressed', 'true');
        applyFilters();
      });
    });
  }

  function preSelectCutFromUrl() {
    var shape = new URLSearchParams(window.location.search).get('shape') || '';
    if (!shape) return;
    var btn = document.querySelector('#rb-setting-shape-filters [data-cut="' + shape.toLowerCase() + '"]');
    if (btn) {
      document.querySelectorAll('#rb-setting-shape-filters [data-cut]').forEach(function (b) {
        b.classList.remove('rb-filter-btn--active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('rb-filter-btn--active');
      btn.setAttribute('aria-pressed', 'true');
      applyFilters();
    }
  }

  function updateCount(count) {
    var el = document.getElementById('rb-setting-count');
    if (!el) return;
    if (count === undefined) {
      count = document.querySelectorAll('#rb-settings-grid .rb-setting-card').length;
    }
    el.textContent = count + ' montura' + (count !== 1 ? 's' : '')
      + ' disponible' + (count !== 1 ? 's' : '');
  }

  // ── Boot ─────────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
